import { NavBar, Hero } from "@/components/landing/Hero";
import { TeSuena, Problema, EnfoqueEditorial, QuienesSomos, Conseguiras, Formas, EsParaTi } from "@/components/landing/Story";
import { Incluye, ComoFunciona, Soporte } from "@/components/landing/Product";
import { GuiaGratis, RabietasTeaser, Precio, Faq, Sesion, Cierre, StickyWhatsApp } from "@/components/landing/Offer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="pb-28 md:pb-0">
      <NavBar />
      <Hero />
      <EnfoqueEditorial />
      <TeSuena />
      <Problema />
      <QuienesSomos />
      <Conseguiras />
      <Formas />
      <Incluye />
      <Soporte />
      <ComoFunciona />
      <EsParaTi />
      <GuiaGratis />
      <Precio />
      <Faq />
      <Sesion />
      <Cierre />
      <RabietasTeaser />
      <StickyWhatsApp />
    </main>
  );
}
